import { Icon, type IconName } from './Icon';

export interface TabItem<K extends string = string> {
  key: K;
  label: string;
  icon: IconName;
  iconOutline?: IconName;
  badge?: number;
}

export interface TabBarProps<K extends string> {
  items: TabItem<K>[];
  value: K;
  onChange: (key: K) => void;
}

/** Bottom tab bar. Active tab is primary green icon plus label; badges are numeric only. */
export function TabBar<K extends string>({ items, value, onChange }: TabBarProps<K>) {
  return (
    <nav
      className="fw-tabbar"
      style={{ gridTemplateColumns: `repeat(${Math.max(items.length, 1)}, 1fr)` }}
    >
      {items.map((it) => {
        const active = it.key === value;
        return (
          <button
            key={it.key}
            type="button"
            onClick={() => onChange(it.key)}
            aria-current={active ? 'page' : undefined}
            className={`fw-tab${active ? ' fw-tab--active' : ''}`}
          >
            <span className="fw-tab__icon">
              <Icon name={active ? it.icon : (it.iconOutline ?? it.icon)} size={24} />
              {it.badge ? <span className="fw-tab__badge fw-tnum">{it.badge}</span> : null}
            </span>
            <span className="fw-tab__label">{it.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
